import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const Notes = () => {
  return (
    <div>
     
      <div className="m-auto h-svh w-3/4">
        <h1 className="text-xl font-bold mb-2">My Browsers and Extensions</h1>
        <h2 className="text-lg font-semibold">Primary Browser:</h2>
        <p className="mb-2">Brave</p>
        <h2 className="text-lg font-semibold">Secondary Browser:</h2>
        <p className="mb-2">Chrome</p>

        <h2 className="text-lg font-semibold">Extensions:</h2>
        <ul className="list-disc list-inside mb-4">
          <li>EditThisCookie</li>
          <li>Postman Interceptor</li>
          <li>JSON Viewer</li>
          <li>Wappalyzer</li>
          <li>Video Playback Speed Controller</li>
          <li>React Developer Tools</li>
          <li>Sponsor Block</li>
          <li>Unhook</li>
        </ul>

        <h2 className="text-lg font-semibold">Coding:</h2>
        <p className="mb-2">I use VS Code most of the time.</p>

        <h2 className="text-lg font-semibold">Theme:</h2>
        <p className="mb-2">Dark Chai</p>
      </div>

    </div>
  );
};

export default Notes;
